import React from "react";
import "../components/SwiadczenieWspierajace.css";
import VN from "../components/VN";
import { useContext } from "react";
import { UserDataContext } from "../components/UserDataContext";

const steps = [
  {
    number: 1,
    title: "Złóż wniosek do WZON",
    subtitle: "Wojewódzki Zespół ds. Orzekania o Niepełnosprawności",
    items: [
      "Wniosek możesz złożyć osobiście, przez pełnomocnika lub online.",
      "Do wniosku dołącz dokumentację medyczną i inne potrzebne załączniki.",
    ],
  },
  {
    number: 2,
    title: "Ocena potrzeby wsparcia",
    items: [
      "WZON przeprowadza ocenę sytuacji osoby ubiegającej się o świadczenie.",
      "Analizowana jest dokumentacja.",
      "Przeprowadzana jest rozmowa lub wywiad.",
      "Ustalany jest poziom potrzeby wsparcia.",
    ],
  },
  {
    number: 3,
    title: "Otrzymasz decyzję z WZON",
    items: [
      "Decyzja zawiera liczbę punktów określających poziom potrzeby wsparcia.",
      "Do uzyskania świadczenia potrzebne jest co najmniej 70 punktów.",
    ],
  },
  {
    number: 4,
    title: "Złóż wniosek do ZUS",
    items: [
      "Po otrzymaniu decyzji WZON możesz złożyć wniosek o świadczenie wspierające.",
      "Wniosek można złożyć elektronicznie lub przez pełnomocnika.",
      "Do wniosku potrzebna jest decyzja WZON.",
    ],
  },
  {
    number: 5,
    title: "ZUS rozpatruje wniosek",
    items: [
      "ZUS sprawdza przekazane dokumenty.",
      "Może poprosić o dodatkowe informacje.",
      "Po spełnieniu warunków świadczenie zostaje przyznane.",
    ],
  },
  {
    number: 6,
    title: "Otrzymujesz świadczenie",
    items: [
      "Świadczenie wypłacane jest co miesiąc przez ZUS.",
      "Wysokość świadczenia zależy od liczby punktów przyznanych przez WZON.",
    ],
  },
];

const supportLevels = [
  { points: "70–74 pkt", percentage: "40%" },
  { points: "75–79 pkt", percentage: "60%" },
  { points: "80–84 pkt", percentage: "80%" },
  { points: "85–89 pkt", percentage: "120%" },
  { points: "90–94 pkt", percentage: "180%" },
  { points: "95–100 pkt", percentage: "220%" },
];

export default function SwiadczenieWspierajace() {
  const { userData } = useContext(UserDataContext);

  return (
    <div>
      <VN userData={userData} />
      <section className="swiadczenie">
        <div className="container">
          <header className="swiadczenie-header">
            <span className="section-label">ŚWIADCZENIE WSPIERAJĄCE</span>

            <h1>Jak uzyskać świadczenie wspierające?</h1>

            <p>
              Zobacz krok po kroku, jak wygląda proces uzyskania świadczenia
              wspierającego – od wniosku do WZON aż do wypłaty świadczenia przez
              ZUS.
            </p>
          </header>

          <div className="row g-4">
            <div className="col-lg-8">
              <div className="steps">
                {steps.map((step, index) => (
                  <React.Fragment key={step.number}>
                    <article className="step-card">
                      <div className="step-number">{step.number}</div>

                      <div className="step-content">
                        <h2>{step.title}</h2>

                        {step.subtitle && (
                          <div className="step-subtitle">{step.subtitle}</div>
                        )}

                        <ul>
                          {step.items.map((item, i) => (
                            <li key={i}>{item}</li>
                          ))}
                        </ul>
                      </div>
                    </article>

                    {index < steps.length - 1 && (
                      <div className="step-arrow">↓</div>
                    )}
                  </React.Fragment>
                ))}
              </div>
            </div>

            <div className="col-lg-4">
              <aside className="info-box important">
                <h3>Ważne</h3>

                <p>
                  Bez decyzji WZON określającej poziom potrzeby wsparcia nie
                  można przejść do kolejnego etapu ubiegania się o świadczenie.
                </p>

                <strong>Komisja WZON ustala liczbę punktów.</strong>
              </aside>

              <aside className="info-box levels">
                <h3>Skala punktów</h3>

                <div className="levels-list">
                  {supportLevels.map((level) => (
                    <div className="level-row" key={level.points}>
                      <span>{level.points}</span>

                      <strong>{level.percentage}</strong>
                    </div>
                  ))}
                </div>

                <p className="level-description">
                  Procent oznacza część renty socjalnej stanowiącą podstawę
                  obliczenia świadczenia.
                </p>
              </aside>

              <aside className="info-box remember">
                <h3>Pamiętaj</h3>

                <ul>
                  <li>Zadbaj o komplet dokumentacji medycznej.</li>
                  <li>Odpowiadaj na wezwania WZON i ZUS.</li>
                  <li>Sprawdzaj status swojego wniosku.</li>
                  <li>Od decyzji można się odwołać.</li>
                </ul>
              </aside>
            </div>
          </div>

          <div className="process-summary">
            <h2>Cały proces w skrócie</h2>

            <div className="process-flow">
              <div>
                <span>1</span>
                Wniosek do WZON
              </div>

              <b>→</b>

              <div>
                <span>2</span>
                Ocena
              </div>

              <b>→</b>

              <div>
                <span>3</span>
                Decyzja
              </div>

              <b>→</b>

              <div>
                <span>4</span>
                Wniosek do ZUS
              </div>

              <b>→</b>

              <div>
                <span>5</span>
                Rozpatrzenie
              </div>

              <b>→</b>

              <div>
                <span>6</span>
                Wypłata
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
